import React, { useRef } from 'react'

import { Button, Input, Span } from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import Draggable from 'react-draggable'
import { COLORS, SPACING } from 'utils'

import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled
} from './ModalJustify.styles'

interface IModal {
  toggleModal: () => void
  handleJustify?: () => void
  onChangeText?: React.Dispatch<React.SetStateAction<string>>
  defaultValue: string
  txJustificativa?: string
  showModal: boolean
  viewMode?: boolean
  cdStatus?: string | null
  value?: any
}

export const ModalJustify = ({
  showModal,
  toggleModal,
  handleJustify,
  onChangeText,
  txJustificativa,
  defaultValue,
  cdStatus,
  value
}: IModal) => {
  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      showModal={showModal}
      reference={draggableReference}
      onClose={toggleModal}
      width={'md'}
    >
      <DialogTitleStyled>Justificativa</DialogTitleStyled>
      {
        txJustificativa ? (
          <>
            <DialogContentStyled>
              <Span text={txJustificativa} fontSize="0.938rem" color={COLORS.black} />
          </DialogContentStyled>
          </>
        ) : (
          <>
            <DialogContentStyled>
            <Input
              label="Digite a justificativa para o documento"
              defaultValue={defaultValue}
              value={value}
              disabled={!['Pendente', 'Recusado', null].includes(cdStatus)}
              onChange={(event) => onChangeText(event.target.value)}
            />
          </DialogContentStyled>
          </>
        )
      }
      {['Pendente', 'Recusado', null].includes(cdStatus) ? (
        <DialogActionsStyled>
          <Button
            text="Limpar"
            variantButton="text"
            onClick={() => onChangeText('')}
          />
          <Button
            text="Voltar"
            variantButton="outlined"
            backgroundColor={COLORS.white}
            textColor={COLORS.black}
            marginRight={SPACING.spacing20}
            borderColor={COLORS.black}
            onClick={toggleModal}
          />
          <Button
            text="Salvar"
            onClick={() => {
              toggleModal()
              handleJustify()
              resetModalState(draggableReference)
            }}
          />
        </DialogActionsStyled>
      ) : (
        <DialogActionsStyled>
          <Button
            text="Fechar"
            onClick={() => {
              toggleModal()
              resetModalState(draggableReference)
            }}
          />
        </DialogActionsStyled>
      )}
    </DraggableDialog>
  )
}